<script>
export default {
  data() {
    return {
      loading: false,
      filterOrder: 'orders',
      list: [],
    }
  },
  created() {
    this.tryToFetchRanking()
  },
  methods: {
    async tryToFetchRanking(sort = 'orders') {
      this.loading = true
      this.list = await this.$store.dispatch('dashboard/fetchRanking', {
        sort,
      })
      this.loading = false
    },
    redirectProductList(id, show = undefined) {
      this.$router.push({
        name: 'products',
        params: {
          productId: id || undefined,
          showAddDialog: show,
        },
      })
    },
    indexMethod(index) {
      return '#' + (index + 1)
    },
  },
}
</script>

<template>
  <el-card class="box-card" shadow="never">
    <div slot="header" class="header">
      <h3 class="block-title">
        預訂項目排行
      </h3>
      <div>
        <template v-can="'redirectProducts'">
          <el-button type="primary" plain @click="redirectProductList('')"
            ><BaseIcon name="th" /> 檢視所有預訂項目</el-button
          >
          <el-button type="primary" @click="redirectProductList('', true)"
            ><BaseIcon name="plus" /> 新增預訂項目</el-button
          >
        </template>
      </div>
    </div>
    <span>排序： </span>
    <el-radio-group
      v-model="filterOrder"
      :class="$style['sort-group']"
      @change="tryToFetchRanking"
    >
      <el-radio-button label="orders">近七日最多訂購預訂項目</el-radio-button>
      <el-radio-button label="pageviews">近七日瀏覽排行</el-radio-button>
    </el-radio-group>
    <el-table
      v-loading="loading"
      element-loading-text="取得訂單資訊中"
      :data="list"
    >
      <el-table-column label="#" :index="indexMethod" type="index" width="50">
      </el-table-column>
      <el-table-column label="預訂項目" prop="name" width="400">
      </el-table-column>
      <el-table-column v-slot="{ row }" label="訂單數量">
        <div
          ><BaseIcon name="clipboard-list" /> {{ row.lastWeekOrdersCount }}</div
        >
      </el-table-column>
      <el-table-column v-slot="{ row }" label="瀏覽人數">
        <div :class="$style['flex-center']"
          ><span><BaseIcon name="eye" /> {{ row.lastWeekPageViews }}</span
          ><el-divider direction="vertical"></el-divider
        ></div>
      </el-table-column>
      <el-table-column v-slot="{ row }" label="動作">
        <el-button type="text" @click="redirectProductList(row.id)">
          <BaseIcon name="edit" />
          修改預訂項目</el-button
        >
      </el-table-column>
    </el-table>
  </el-card>
</template>
<style lang="scss" module>
.flex-center {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.sort-group {
  :global {
    .el-radio-button {
      &:not(.is-active) {
        .el-radio-button__inner {
          border-color: transparent;
        }
      }
      .el-radio-button__inner {
        padding: 6px 15px;
        font-size: 12px;
      }
    }
  }
}
</style>
